// When Focus asks the server to top the queue back up while a seller works.
// The top-up is idempotent, so these only decide how often to spend a request.

/** Quiet time after the last outcome save before the refill goes out. */
export const REFILL_DEBOUNCE_MS = 2_000
/** Background refill for a seller who sits in Focus without saving anything. */
export const REFILL_INTERVAL_MS = 5 * 60_000

/** Collapses a burst of calls into one, fired `ms` after the last of them. */
export function debounce(fn: () => void, ms: number): { call: () => void; cancel: () => void } {
  let timer: ReturnType<typeof setTimeout> | undefined
  return {
    call() {
      clearTimeout(timer)
      timer = setTimeout(() => {
        timer = undefined
        fn()
      }, ms)
    },
    cancel() {
      clearTimeout(timer)
      timer = undefined
    },
  }
}
